import useComponentMargin from '@hero/ui-kit/hooks/useComponentMargin';
const useMembershipFilterFormStyles = () => {
    const filterMargin = useComponentMargin({ marginRight: 'regular' });
    const resetButtonMargin = useComponentMargin({ marginBottom: 'regular' });
    const resetButtonWrapMargin = useComponentMargin({ marginTop: 'regular' });
    const filterWrapStyles = {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    };
    const activationFilterStyles = {
        width: '20rem',
        ...filterMargin
    };
    const statusFilterStyles = {
        width: '26rem',
        ...filterMargin
    };
    const planFilterStyles = {
        width: '32rem',
        ...filterMargin
    };
    return {
        filterMargin,
        filterWrapStyles,
        activationFilterStyles,
        statusFilterStyles,
        planFilterStyles,
        resetButtonWrapMargin,
        resetButtonMargin
    };
};
export default useMembershipFilterFormStyles;
